import React from 'react';
import { Grid } from '@mui/material';
import TiptapEditor from 'external/TipTapEditor/TiptapEditor';
function TestRoute() {
  return (
    <Grid
      height='100vh'
      width='100vw'
      container
      alignItems='center'
      justifyContent='center'
      paddingX={20}
      bgcolor='lightgray'
    >
      <TiptapEditor initialContent={''} />
    </Grid>
  );
}

export default TestRoute;
